<template>
  <div class="">
    <div class="bg">
      <div class="bgImg">
        <div class="pageTitle">招生专业</div>
        <img src="@/assets/img/bjing@2x.png" alt="" />
      </div>
    </div>
    <div class="enrollmentMajor" v-if="!isLoading">
      <ul class="lists ">
        <li v-for="(item,index) in listData" :key="index"><span>{{ `${item.specialtyName}(${item.yearsName}-${item.planType})` }}</span></li>
      </ul>
    </div>
  </div>
</template>
<script>
import {getSchoolSpecialZs} from '@/api/schoolInfo'
export default {
  name: "enrollmentMajor",
  data() {
    return {
      listData: [],
      isLoading: true
    };
  },
  props: [],

  created(){
    this.initRequest()
  },
  methods: {
    initRequest() {
      getSchoolSpecialZs().then(res=>{
        this.listData = res
        this.isLoading = false
      })
    }
  },
};
</script>
<style scoped>
/* 背景图片 */
.bgImg {
  position: relative;
  width: 100%;
  height: 272px;
  z-index: 0;
}
.bgImg img {
  width: 100%;
  height: 100%;
}
.bgImg .pageTitle {
  position: absolute;
  top: 82px;
  left: 26px;
  font-size: 25px;
  font-weight: bold;
  color: #FFFFFF;
}
.appName {
  width: 171px;
  background-color: #ffffff4b;
  text-align: center;
  height: 24px;
  line-height: 24px;
  border-radius: 40px;
  font-size: 16px;
  font-weight: 400;
  color: #ffffff;
  position: absolute;
  top: 104px;
  left: 50%;
  transform: translate(-50%, 0);
}


.enrollmentMajor {
  overflow-y: scroll;
  position: relative;
  top: -138px;
  height: calc(100vh - 138px);
  line-height: 25px;
  font-size: 14px;
  margin: 0 9px 10px;
  border-radius: 8px;
  padding: 21px 15px 18px;
  background-color: #ffffff;
  
}
.enrollmentMajor .title {
  font-size: 16px;
  text-align: center;
  font-weight: bold;
}
.lists {
  padding-left: 25px;
  list-style-type: disc;
  color: #D02B3A;
  height: calc(100vh - 20px);
  overflow-y: scroll;
}
.lists li {
  margin-bottom: 7px;
}
.lists span {
  color: #333;
}
</style>